import { createFileRoute } from "@tanstack/react-router";

import Dashboard from "../-components/Dashboard";

export const Route = createFileRoute("/_app/_dashboard/dashboard")({
  component: Dashboard,
});
